import { PendingCourseStatusDisplayStrategy } from './../strategies/pending_course_status_display_strategy';
import { key } from 'core-ts-types';
import { TimeUtility } from 'utility-ts-type';

export class Course {
  id: number;
  nk: string;
  code: string;
  subject: string;
  number: string;
  name: string;
  college_nk: key;
  display: string;
  created_ts: string;
  isPending: boolean = false;
  isRejected: boolean = false;
  statusDisplay: string = '';
  createdDisplay: string = '';
  grade: string = '';
  credits: string = '';
  term_type: string = '';
  term_year: string = '';
  isReviewed: boolean = true;
  status: string;
  resolved_ts?: string;

  constructor(course: any) {
    _.merge(this, course);
    this.display = `${this.code} ${this.name}`;
    this.isPending = _.get<any, boolean>(course, 'is_pending') || this.isPending;
    const rejectedStatuses = ['resolved_without_review', 'resolved_does_not_receive_credit'];
    this.isRejected = rejectedStatuses.includes(this.status);
    this.statusDisplay = PendingCourseStatusDisplayStrategy.evaluate(this.status, 'Pending review');
    this.createdDisplay = this.created_ts ? moment.utc(parseInt(this.created_ts) * 1000).format('MM/DD/YY') : '--';
  }

  static build(course: any): Course {
    return new Course(course);
  }
}

angular.module('capability-ng-transfer').factory('ngCourseBuilder', (): typeof Course => {
  return Course;
});



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/course_builder.ts